import { Fragment, ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

export const SystemContainer = (): ReactElement => (
  <Fragment>
    <div className="pmi-h-100">
      <Outlet />
    </div>
  </Fragment>
);

SystemContainer.displayName = 'SystemContainer';
